var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { RouterConstants } from "../../../configuration/router.constants";
import { clientComponentModuleId } from "../render-engine/render-engine.helper";
import { activationStrategy } from "aurelia-router";
import { NotificationType } from "../../../services/basics/notification-client.service";
import { LotteryClientModel } from "../../../models/modules/lotteryplatform-client.models";
import { bindable, computedFrom } from "aurelia-framework";
import { TicketStatusEnum, CurrencyCodeEnum } from "../../../models/modules/lotteryplatofrm.models";
import * as Enumerable from "linq";
import { Guid } from "../../../utilities/guid";
import { Client } from "../../../views/app/client/client";
import { BaseTemplate } from "./base-template";
var BaseChooseTickets = /** @class */ (function (_super) {
    __extends(BaseChooseTickets, _super);
    function BaseChooseTickets(router, tokenClient, gamePlayerTicketClientService, bindingSignaler, notificationClientService, i18n, lotteryClientService, eventAggregator, dialogClientService, element) {
        var _this = _super.call(this, router, i18n, lotteryClientService, dialogClientService, tokenClient) || this;
        _this.gamePlayerTicketClientService = gamePlayerTicketClientService;
        _this.bindingSignaler = bindingSignaler;
        _this.notificationClientService = notificationClientService;
        _this.lotteryClientService = lotteryClientService;
        _this.eventAggregator = eventAggregator;
        _this.element = element;
        _this.tickets = [];
        _this.freeTicketToggles = new Map();
        _this.discountOffers = [];
        _this.bonusNumbers = [];
        _this.mainNumbers = [];
        _this.drawnBonusNumbers = [];
        _this.drawnMainNumbers = [];
        _this.previewData = [
            {
                discount: 5,
                price: 2,
                draws: 2,
                numberOfDraws: 2
            },
            {
                discount: 10,
                price: 2,
                draws: 4,
                numberOfDraws: 4
            },
            {
                discount: 20,
                price: 2,
                draws: 8,
                numberOfDraws: 8
            },
            {
                discount: 30,
                price: 2,
                draws: 12,
                numberOfDraws: 12
            }
        ];
        _this.ghostTickets = Enumerable.range(1, _this.getTicketsPerLine(), 1).toArray();
        _this.showPurchaseStep = false;
        _this.isDialog = false;
        _this.isFromCart = false;
        _this.cartGuid = null;
        _this.bundleGuid = null;
        _this.draws = null;
        // used for css animation
        _this.isFirstTime = true;
        _this._ticketsMaxCount = 20;
        _this.isLoadingTickets = true;
        _this.removedTickets = [];
        return _this;
    }
    BaseChooseTickets.prototype.determineActivationStrategy = function () {
        return activationStrategy.replace;
    };
    BaseChooseTickets.prototype.activate = function (params) {
        var promise = _super.prototype.activate.call(this, params);
        if (params && params.lottery)
            this.lottery = params.lottery;
        if (params && params.brandLotteryId)
            this.brandLotteryId = params.brandLotteryId;
        if (params && params.showPurchaseStep)
            this.showPurchaseStep = params.showPurchaseStep;
        if (params && params.key)
            this.key = params.key;
        if (params && params.isDialog)
            this.isDialog = params.isDialog;
        if (params && params.isFromCart)
            this.isFromCart = params.isFromCart;
        if (params && params.cartGuid)
            this.cartGuid = params.cartGuid;
        if (params && params.bundleGuid)
            this.bundleGuid = params.bundleGuid;
        if (params && params.draws)
            this.draws = params.draws;
        this.loadLotteryDetails();
        return promise;
    };
    BaseChooseTickets.prototype.getTicketsPerLine = function () {
        return 5;
    };
    BaseChooseTickets.prototype.canAddLine = function () {
        return (this.getTicketsPerLine() + this.tickets.length) <= this._ticketsMaxCount;
    };
    BaseChooseTickets.prototype.checkSubscribeAndDefaultDiscount = function () {
        var _this = this;
        if (this.isSubscribe) // if is subscribe pressed then autopick all and select the highest discount
         {
            this.quickPick();
            var highest = this.discountOffers[this.discountOffers.length - 1];
            this.selectOffer(highest, false);
        }
        else {
            var discount = Enumerable.from(this.discountOffers).firstOrDefault(function (x) { return _this.draws && x.numberOfDraws == _this.draws; });
            var defaultDiscount = Enumerable.from(this.discountOffers).firstOrDefault(function (x) { return x.isDefault; });
            var ticketDraw = null;
            if (this.tickets && this.tickets[0] && this.tickets[0].draws)
                ticketDraw = Enumerable.from(this.discountOffers).firstOrDefault(function (x) { return x.numberOfDraws == _this.tickets[0].draws; });
            if (discount) {
                this.selectOffer(discount, false);
            }
            else if (ticketDraw) {
                this.selectOffer(ticketDraw, false);
            }
            else if (defaultDiscount) {
                this.selectOffer(defaultDiscount, false);
            }
            else if (this.discountOffers[0]) {
                this.selectOffer(this.discountOffers[0], false);
            }
        }
    };
    Object.defineProperty(BaseChooseTickets.prototype, "lotteryGroups", {
        get: function () {
            if (this.lottery && this.lottery.lotteryGroups)
                return this.lottery.lotteryGroups.map(function (x) { return ({ id: x.brandLotteryId, value: "x" + x.increaseRate }); });
            return null;
        },
        enumerable: false,
        configurable: true
    });
    BaseChooseTickets.prototype.switchValueChanged = function (event) {
        var isChecked = event.detail.value;
        if (isChecked)
            this.changeLottery({ detail: { value: this.lotteryGroups[1].id, loaded: function (any) { } } });
        else
            this.changeLottery({ detail: { value: this.lotteryGroups[0].id, loaded: function (any) { } } });
    };
    BaseChooseTickets.prototype.sliderValueChanged = function (event) {
        this.changeLottery(event);
    };
    BaseChooseTickets.prototype.changeLottery = function (event) {
        var _this = this;
        clearTimeout(this._sliderTimeOut);
        this._sliderTimeOut = setTimeout(function () {
            var self = _this;
            var paramsEvent = { detail: { value: event.detail.value, loaded: function () {
                        self.lotteryChanged();
                    } }, bubbles: true };
            var changeValueEvent = new CustomEvent("change-lottery", paramsEvent);
            _this.element.dispatchEvent(changeValueEvent);
        }, 500);
    };
    BaseChooseTickets.prototype.closeDialog = function () {
        this.dialogClient.hide();
    };
    BaseChooseTickets.prototype.lotteryChanged = function () {
        this.loadLotteryDetails();
    };
    BaseChooseTickets.prototype.brandLotteryIdChanged = function () {
        this.loadLotteryDetails();
    };
    BaseChooseTickets.prototype.loadLotteryDetails = function () {
        var _this = this;
        this.brandId = this.tokenClient.user.brandId;
        this.countryId = this.tokenClient.getCountryId();
        this.userCurrency = this.tokenClient.getUserCurrency();
        if (!this.userCurrency)
            this.userCurrency = {
                currencyId: 1,
                currencyRates: null
            };
        if (this.lottery && (this.brandLotteryId || this.tokenClient.isPreview)) {
            var lotteryBrandDiscountsEnumerable = Enumerable.from(this.lottery.lotteryBrandDiscounts);
            //get the disounts filtered by country id match or null country
            this.discountOffers = this.tokenClient.isPreview ?
                this.previewData :
                lotteryBrandDiscountsEnumerable.orderBy(function (x) { return x.countryId; }).where(function (x) { return ((x.countryId == _this.countryId) || (x.countryId == null)); }).orderBy(function (x) { return x.numberOfDraws; }).toArray();
            //get ticket prices according to user country and currency of the user (order by lotteryJackpotRangeId so that those that have this set are selected first)
            var lotteryBrandPricesEnumerable = Enumerable.from(this.lottery.lotteryBrandPrices).orderByDescending(function (x) { return x.lotteryJackpotRangeId; });
            //find the current jackpot range so that we can choose the ticket price for that range 
            this.ticketPrice = this.tokenClient.isPreview ?
                {
                    currencyId: Enumerable.from(this.tokenClient.currencies).where(function (x) { return x.currencyCode && x.currencyCode.toLowerCase() == CurrencyCodeEnum.Eur.toLowerCase(); }).select(function (x) { return x.currencyId; }).firstOrDefault(),
                    price: this.previewData[0].price
                } :
                this.getPrice(lotteryBrandPricesEnumerable);
            this.mainNumbers = Enumerable.range(this.lottery.drawMinimumNumber, (this.lottery.drawMaximumNumber + 1) - this.lottery.drawMinimumNumber).toArray();
            this.drawnMainNumbers = Enumerable.range(1, this.lottery.drawnNumbers).toArray();
            if (this.lottery.drawnBonusMinimumNumber != null && this.lottery.drawnBonusMaximumNumber != null) {
                this.bonusNumbers = Enumerable.range(this.lottery.drawnBonusMinimumNumber, (this.lottery.drawnBonusMaximumNumber + 1) - this.lottery.drawnBonusMinimumNumber).toArray();
                this.drawnBonusNumbers = Enumerable.range(1, this.lottery.drawnBonusNumbers).toArray();
            }
            else {
                this.bonusNumbers = [];
                this.drawnBonusNumbers = [];
            }
            this.loadSavedTickets();
            this.validateRequest(null);
            this.brandLotterySliderValue = this.lottery.brandLotteryId;
        }
    };
    BaseChooseTickets.prototype.getPrice = function (enumerable) {
        var _this = this;
        var currentJackPotRange = Enumerable.from(this.lottery.jackpotRanges).firstOrDefault(function (x) { return _this.lottery.totalJackpotInEuro >= x.rangeFrom && _this.lottery.totalJackpotInEuro <= x.rangeTo; });
        var currentJackPotRangeId = currentJackPotRange ? currentJackPotRange.lotteryJackpotRangeId : null;
        var query = enumerable.where(function (x) { return x.currencyId == _this.userCurrency.currencyId; });
        if (query.any(function (x) { return x.countryId == _this.countryId; }))
            query = query.where(function (x) { return x.countryId == _this.countryId; });
        else
            query = query.where(function (x) { return x.countryId == null; });
        if (query.any(function (x) { return x.lotteryJackpotRangeId == currentJackPotRangeId; }))
            query = query.where(function (x) { return x.lotteryJackpotRangeId == currentJackPotRangeId; });
        else
            query = query.where(function (x) { return x.lotteryJackpotRangeId == null; });
        return query.firstOrDefault();
    };
    //To override for specific login in template
    BaseChooseTickets.prototype.onLotteryDetailsLoaded = function () { };
    BaseChooseTickets.prototype.loadSavedTickets = function () {
        var _this = this;
        if (this.tokenClient.isPreview) { // for admin preview
            this.isLoadingTickets = false;
            this.setTickets([]);
            this.checkSubscribeAndDefaultDiscount();
            this.updateTicketNumbers();
        }
        else {
            var freeCountPromise = this.lottery && this.brandLotteryId
                ? this.lotteryClientService.refreshFreeTicketCount(this.brandLotteryId)
                : Promise.resolve(this.lottery ? this.lottery.freeTicketCount || 0 : 0);
            //timeout needed for edit of ticket without it bindable variables where not being setup in time
            var savedTicketsPromise = new Promise(function (resolve, reject) {
                setTimeout(function () {
                    _this.gamePlayerTicketClientService.getSavedTickets({
                        cartGuid: _this.cartGuid,
                        brandLotteryId: _this.brandLotteryId,
                        ticketStatus: _this.isFromCart ? TicketStatusEnum.AddedToCart : TicketStatusEnum.New
                    }).then(resolve, reject);
                }, 1000);
            });
            Promise.all([freeCountPromise, savedTicketsPromise]).then(function (_a) {
                var _b = __read(_a, 2), count = _b[0], x = _b[1];
                if (_this.lottery)
                    _this.lottery.freeTicketCount = count;
                _this.isLoadingTickets = false;
                _this._ticketsMaxCount = x.maxCount;
                _this.setTickets(x.tickets);
                _this.bindingSignaler.signal('refresh-add-lines');
                _this.checkSubscribeAndDefaultDiscount();
                _this.updateTicketNumbers();
                _this.checkSubscribeAndDefaultDiscount();
                _this.onLotteryDetailsLoaded();
                // When editing from cart, the backend subtracted the free tickets in this cart item
                // from the available count. Add them back since they belong to the item being edited.
                if (_this.isFromCart && _this.lottery) {
                    _this.lottery.freeTicketCount += _this.freeTicketsUsed;
                }
            }, function (x) {
                _this.isLoadingTickets = false;
                _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
            });
        }
    };
    BaseChooseTickets.prototype.setTickets = function (tickets) {
        var e_1, _a;
        this.tickets = [];
        this.freeTicketToggles = new Map();
        var ordered = Enumerable.from(tickets).orderBy(function (x) { return x.sequenceNumber; }).toArray();
        // set number of draws
        this.checkSubscribeAndDefaultDiscount();
        this.updateTotalPrice();
        try {
            // set saved tickets
            for (var ordered_1 = __values(ordered), ordered_1_1 = ordered_1.next(); !ordered_1_1.done; ordered_1_1 = ordered_1.next()) {
                var item = ordered_1_1.value;
                var ticket = {
                    ticketId: item.gamePlayerTicketLineId,
                    guid: item.ticketGuid,
                    main: Enumerable.from(item.mainPicks.split(",")).where(function (x) { return x != "" && x != null; }).select(function (x) { return Number(x); }).toArray(),
                    bonus: Enumerable.from(item.bonusPicks.split(",")).where(function (x) { return x != "" && x != null; }).select(function (x) { return Number(x); }).toArray(),
                    draws: item.numberOfDraws
                };
                if (item.isFreeTicket) {
                    this.freeTicketToggles.set(item.ticketGuid, true);
                }
                this.tickets.push(ticket);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (ordered_1_1 && !ordered_1_1.done && (_a = ordered_1.return)) _a.call(ordered_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var remainder = (this.tickets.length / this.getTicketsPerLine()) % 1;
        var remaining = this.getTicketsPerLine() - (remainder * this.getTicketsPerLine());
        // add missing items in line
        if (remaining != this.getTicketsPerLine() || this.tickets.length == 0)
            for (var i = 1; i <= remaining; i++) {
                var ticket = {
                    guid: Guid.generateGuid(),
                    main: [],
                    bonus: []
                };
                this.tickets.push(ticket);
            }
    };
    BaseChooseTickets.prototype.addBonusNumber = function (ticket, number) {
        var index = ticket.bonus.indexOf(number);
        if (index >= 0) {
            ticket.bonus.splice(index, 1);
        }
        else if (ticket.bonus.length < this.lottery.drawnBonusNumbers) {
            ticket.bonus.push(number);
        }
        this.updateTicketNumbers();
        this.save(ticket);
    };
    BaseChooseTickets.prototype.reset = function (ticket) {
        this.resetInternal(ticket);
        this.save(ticket);
    };
    BaseChooseTickets.prototype.resetInternal = function (ticket) {
        ticket.main = [];
        ticket.bonus = [];
        this.updateTicketNumbers();
        this.removedTickets.push(ticket);
    };
    BaseChooseTickets.prototype.shouldDeleteTicketOnMobile = function () {
        return true;
    };
    BaseChooseTickets.prototype.quickPick = function () {
        var _this = this;
        this.tickets.forEach(function (x) { return _this.pickRandomInternal(x); });
        this.saveBulk(this.tickets);
        this.updateTotalPrice();
    };
    BaseChooseTickets.prototype.resetAll = function () {
        var _this = this;
        this.tickets.forEach(function (x) { return _this.resetInternal(x); });
        this.saveBulk(this.tickets);
        this.updateTotalPrice();
    };
    BaseChooseTickets.prototype.pickRandom = function (ticket) {
        this.pickRandomInternal(ticket);
        this.save(ticket);
    };
    BaseChooseTickets.prototype.pickRandomInternal = function (ticket) {
        var numbersToPick = 0;
        var bonusToPick = 0;
        if (this.lottery.drawnNumbers === ticket.main.length) {
            ticket.main = [];
        }
        if (this.lottery.drawnBonusNumbers === ticket.bonus.length) {
            ticket.bonus = [];
        }
        numbersToPick = this.lottery.drawnNumbers - ticket.main.length;
        bonusToPick = this.lottery.drawnBonusNumbers - ticket.bonus.length;
        for (var i = 1; i <= numbersToPick; i++) {
            var number = 0;
            do {
                number = this.getRandom(this.lottery.drawMinimumNumber, this.lottery.drawMaximumNumber);
            } while (Enumerable.from(ticket.main).contains(number));
            ticket.main.push(number);
        }
        for (var i = 1; i <= bonusToPick; i++) {
            var number = 0;
            do {
                number = this.getRandom(this.lottery.drawnBonusMinimumNumber, this.lottery.drawnBonusMaximumNumber);
            } while (Enumerable.from(ticket.bonus).contains(number));
            ticket.bonus.push(number);
        }
        this.updateTicketNumbers();
    };
    BaseChooseTickets.prototype.addMainNumber = function (ticket, number) {
        var index = ticket.main.indexOf(number);
        if (index >= 0) {
            ticket.main.splice(index, 1);
        }
        else if (ticket.main.length < this.lottery.drawnNumbers) {
            ticket.main.push(number);
        }
        this.updateTicketNumbers();
        this.save(ticket);
    };
    BaseChooseTickets.prototype.addLines = function () {
        if (this.canAddLine()) {
            for (var i = 1; i <= this.getTicketsPerLine(); i++) {
                var ticket = this.getNewTicket();
                this.tickets.push(ticket);
            }
            setTimeout(function () {
                var leftPos = $('.tickets').scrollLeft() + $(".tickets").find(".ticket").last().offset().left;
                $(".tickets").animate({ scrollLeft: leftPos }, 800);
            });
            this.bindingSignaler.signal("refresh-add-lines");
        }
        else {
            this.notificationClientService.show(this.i18n.tr("error"), this.i18n.tr("number-of-line-exceeded-message"), NotificationType.Error);
        }
    };
    BaseChooseTickets.prototype.getNewTicket = function () {
        return {
            guid: Guid.generateGuid(),
            main: [],
            bonus: []
        };
    };
    BaseChooseTickets.prototype.removeLines = function () {
        // 5 is the length 6 is the index
        var startIndex = this.tickets.length - this.getTicketsPerLine();
        for (var index = 0; index < this.getTicketsPerLine(); index++) {
            var ticket = this.tickets[startIndex];
            this.gamePlayerTicketClientService.deleteTicket({
                ticketGuid: ticket.guid,
                ticketId: ticket.ticketId,
                brandLotteryId: this.brandLotteryId,
                cartGuid: this.cartGuid
            });
            this.tickets.splice(startIndex, 1);
        }
        this.updateTotalPrice();
        this.bindingSignaler.signal("refresh-add-lines");
    };
    Object.defineProperty(BaseChooseTickets.prototype, "anySelectedTickets", {
        get: function () {
            var _this = this;
            return this.tickets ? Enumerable.from(this.tickets)
                .any(function (x) { return _this.getRemainingBonus(x) == 0 && _this.getRemainingMain(x) == 0; }) : false;
        },
        enumerable: false,
        configurable: true
    });
    BaseChooseTickets.prototype.showClientDetailsDialog = function () {
        this.dialogClient.show(clientComponentModuleId("common/client-details-dialog"), this, false, true);
    };
    BaseChooseTickets.prototype.buyTickets = function (clientDetails) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.isBuyingTickets) {
                reject();
                return;
            }
            var tickets = Enumerable.from(_this.tickets)
                .where(function (x) { return _this.getRemainingBonus(x) == 0 && _this.getRemainingMain(x) == 0; }).toArray();
            if (tickets.length <= 0) {
                _this.noTicketsToPurchase();
            }
            else {
                if (_this.tokenClient.isAgent() && !clientDetails) {
                    _this.showClientDetailsDialog();
                    resolve({});
                }
                else {
                    _this.isUnauthorized = false;
                    _this.isBuyingTickets = true;
                    var requests = Enumerable.from(tickets).select(function (x) { return _this.getCreateTicketRequest(x); }).toArray();
                    if (_this.validateRequest(requests[0]))
                        _this.gamePlayerTicketClientService.purchaseTickets({
                            tickets: requests,
                            purchasedFromCart: false,
                            clientDetails: clientDetails,
                            gameIdentifier: _this.lottery.gameIdentifier
                        }).then(function (x) {
                            var e_2, _a;
                            _this.isBuyingTickets = false;
                            try {
                                for (var tickets_1 = __values(tickets), tickets_1_1 = tickets_1.next(); !tickets_1_1.done; tickets_1_1 = tickets_1.next()) {
                                    var ticket = tickets_1_1.value;
                                    var index = _this.tickets.indexOf(ticket);
                                    _this.tickets.splice(index, 1);
                                    _this.tickets.push(_this.getNewTicket());
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (tickets_1_1 && !tickets_1_1.done && (_a = tickets_1.return)) _a.call(tickets_1);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                            _this.updateTicketNumbers();
                            if (!_this.tokenClient.isAgent()) // do not redirect if is agent since we show the ticket
                                _this.navigateToLobby();
                            _this.notificationClientService.show(_this.i18n.tr(_this.key + "-purchased-tickets-successfully-title"), _this.i18n.tr(_this.key + "-purchased-tickets-successfully-message"), NotificationType.Success);
                            _this.onPurchase();
                            resolve(x);
                        }, function (x) {
                            _this.isUnauthorized = x && x.statusCode == 401 && !_this.tokenClient.user.enableLoginDialog;
                            if (x && !_this.isUnauthorized)
                                _this.notificationClientService.show(_this.i18n.tr("notification-error-title"), _this.i18n.tr(x.response || x), NotificationType.Error);
                            _this.isBuyingTickets = false;
                            reject();
                        });
                    else {
                        _this.isBuyingTickets = false;
                        reject();
                    }
                }
            }
        });
    };
    BaseChooseTickets.prototype.onPurchase = function () { };
    BaseChooseTickets.prototype.addToCart = function () {
        var _this = this;
        if (this.isAddingToCart)
            return;
        this.isAddingToCart = true;
        var tickets = Enumerable.from(this.tickets)
            .where(function (x) { return _this.getRemainingBonus(x) == 0 && _this.getRemainingMain(x) == 0; }).toArray();
        if (!this.tokenClient.isAuthenticated) {
            this.notificationClientService.show(this.i18n.tr(this.key + "-not-authenticated-message"), this.i18n.tr(this.key + "-add-to-cart-not-logged-in-notification-message"), NotificationType.Warning);
        }
        if (tickets.length <= 0) {
            this.isAddingToCart = false;
            this.noTicketsAddedToCart();
        }
        else {
            var requests = Enumerable.from(tickets).select(function (x) { return _this.getCreateTicketRequest(x); }).toArray();
            if (this.validateRequest(requests[0]))
                this.gamePlayerTicketClientService.addTicketsToCart({
                    tickets: requests
                }).then(function (x) {
                    var e_3, _a;
                    _this.isAddingToCart = false;
                    try {
                        for (var tickets_2 = __values(tickets), tickets_2_1 = tickets_2.next(); !tickets_2_1.done; tickets_2_1 = tickets_2.next()) {
                            var ticket = tickets_2_1.value;
                            var index = _this.tickets.indexOf(ticket);
                            _this.tickets.splice(index, 1);
                            _this.tickets.push(_this.getNewTicket());
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (tickets_2_1 && !tickets_2_1.done && (_a = tickets_2.return)) _a.call(tickets_2);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    _this.updateTicketNumbers();
                    _this.navigateToCart();
                    _this.eventAggregator.publish(Client.UpdateCartCount);
                    _this.ticketsAddedToCart();
                    window.dataLayer.push({
                        "event": "navigate_to_cart",
                        "brandLotteryId": _this.brandLotteryId,
                        "openedLotteryName": _this.lottery.lotteryName,
                        "openedLotteryId": _this.lottery.lotteryId,
                    });
                    _this.onAddedToCart();
                }, function (x) {
                    _this.isAddingToCart = false;
                });
            else
                this.isAddingToCart = false;
        }
    };
    BaseChooseTickets.prototype.navigateToCart = function () {
        this.router.navigateToRoute(RouterConstants.RouteNames.Cart);
    };
    BaseChooseTickets.prototype.onAddedToCart = function () { };
    BaseChooseTickets.prototype.selectOffer = function (item, persistDrawChanges) {
        var _this = this;
        if (persistDrawChanges === void 0) { persistDrawChanges = true; }
        this.discountOffers.forEach(function (x) { return x.isSelected = false; });
        item.isSelected = true;
        this.updateTotalPrice();
        // persist draw changes
        if (persistDrawChanges) // save only tickets with selected numbers
            this.saveBulk(Enumerable.from(this.tickets)
                .where(function (x) { return _this.getRemainingBonus(x) != _this.lottery.drawnBonusNumbers && _this.getRemainingMain(x) != _this.lottery.drawnNumbers; }).toArray());
    };
    BaseChooseTickets.prototype.save = function (ticket, force) {
        var _this = this;
        if (force === void 0) { force = false; }
        if (!this.canRevert || force) {
            var request = this.getCreateTicketRequest(ticket);
            if (this.validateRequest(request)) {
                this.gamePlayerTicketClientService.createOrModifyTicket(request).catch(function (x) {
                    _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
                });
            }
        }
    };
    BaseChooseTickets.prototype.saveBulk = function (tickets, force) {
        var _this = this;
        if (force === void 0) { force = false; }
        if (!this.canRevert || force) {
            var requests = Enumerable.from(tickets).select(function (x) { return _this.getCreateTicketRequest(x); }).toArray();
            var valid = Enumerable.from(requests).all(function (x) { return _this.validateRequest(x); });
            if (valid) {
                this.gamePlayerTicketClientService.createOrModifyTicketBulk(requests).catch(function (x) {
                    _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
                });
            }
        }
    };
    BaseChooseTickets.prototype.validateRequest = function (request) {
        var draws = Enumerable.from(this.discountOffers).any();
        if (!draws) {
            this.notificationClientService.show(this.i18n.tr(this.key + "-no-draws-set-up"), "", NotificationType.Warning);
            return false;
        }
        else if (request && request.draws <= 0) {
            this.notificationClientService.show(this.i18n.tr(this.key + "-select-draw-number"), "", NotificationType.Warning);
            return false;
        }
        else if (!this.ticketPrice) {
            this.notificationClientService.show(this.i18n.tr(this.key + "-prices-not-set-for-your-currency"), "", NotificationType.Warning);
            return false;
        }
        return true;
    };
    BaseChooseTickets.prototype.noTicketsToPurchase = function () {
        this.notificationClientService.show(this.i18n.tr(this.key + "-no-tickets-to-purchase"), "", NotificationType.Warning);
    };
    BaseChooseTickets.prototype.updatedCart = function () {
        this.notificationClientService.show(this.i18n.tr(this.key + "-updated-cart-notification-title"), this.i18n.tr(this.key + "-updated-cart-notification-message"), NotificationType.Success);
    };
    BaseChooseTickets.prototype.noTicketsAddedToCart = function () {
        this.notificationClientService.show(this.i18n.tr(this.key + "-no-tickets-to-add-to-cart"), "", NotificationType.Warning);
    };
    BaseChooseTickets.prototype.ticketsAddedToCart = function () {
        this.notificationClientService.show(this.i18n.tr(this.key + "-tickets-added-to-cart"), "", NotificationType.Success);
    };
    BaseChooseTickets.prototype.update = function () {
        var e_4, _a, e_5, _b, e_6, _c;
        var _this = this;
        if (this.isUpdating)
            return;
        this.isUpdating = true;
        if (this.tickets.length <= 0) {
            this.isUpdating = false;
            this.noTicketsAddedToCart();
        }
        else {
            var removedTickets = Enumerable.from(this.removedTickets);
            var promises = [];
            var updatedTickets = Enumerable.from(this.tickets).where(function (x) { return _this.getRemainingNumbers(x) == 0; }).toArray();
            try {
                for (var updatedTickets_1 = __values(updatedTickets), updatedTickets_1_1 = updatedTickets_1.next(); !updatedTickets_1_1.done; updatedTickets_1_1 = updatedTickets_1.next()) {
                    var ticket = updatedTickets_1_1.value;
                    var request = this.getCreateTicketRequest(ticket);
                    if (this.validateRequest(request))
                        promises.push(this.gamePlayerTicketClientService.createOrModifyTicket(request));
                    //when updating we were also deleting a ticket which was added
                    var index = this.removedTickets.indexOf(ticket);
                    if (index >= 0 && removedTickets.any(function (s) { return s.ticketId == ticket.ticketId; })) {
                        this.removedTickets.splice(index, 1);
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (updatedTickets_1_1 && !updatedTickets_1_1.done && (_a = updatedTickets_1.return)) _a.call(updatedTickets_1);
                }
                finally { if (e_4) throw e_4.error; }
            }
            var notFullySelectedTickets = Enumerable.from(this.tickets).where(function (x) { return _this.getRemainingNumbers(x) != 0; }).toArray();
            try {
                for (var notFullySelectedTickets_1 = __values(notFullySelectedTickets), notFullySelectedTickets_1_1 = notFullySelectedTickets_1.next(); !notFullySelectedTickets_1_1.done; notFullySelectedTickets_1_1 = notFullySelectedTickets_1.next()) {
                    var t = notFullySelectedTickets_1_1.value;
                    promises.push(this.gamePlayerTicketClientService.deleteTicket({
                        ticketGuid: t.guid,
                        ticketId: t.ticketId,
                        brandLotteryId: this.brandLotteryId,
                        cartGuid: this.cartGuid
                    }));
                    //when updating we were also deleting a ticket which was added
                    var index = this.removedTickets.indexOf(t);
                    if (index >= 0 && removedTickets.any(function (s) { return s.ticketId == t.ticketId; })) {
                        this.removedTickets.splice(index, 1);
                    }
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (notFullySelectedTickets_1_1 && !notFullySelectedTickets_1_1.done && (_b = notFullySelectedTickets_1.return)) _b.call(notFullySelectedTickets_1);
                }
                finally { if (e_5) throw e_5.error; }
            }
            try {
                for (var _d = __values(this.removedTickets), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var t = _e.value;
                    promises.push(this.gamePlayerTicketClientService.deleteTicket({
                        ticketGuid: t.guid,
                        ticketId: t.ticketId,
                        brandLotteryId: this.brandLotteryId,
                        cartGuid: this.cartGuid
                    }));
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_c = _d.return)) _c.call(_d);
                }
                finally { if (e_6) throw e_6.error; }
            }
            Promise.all(promises).then(function (x) {
                _this.isUpdating = false;
                _this.router.navigateToRoute(RouterConstants.RouteNames.Cart);
                _this.eventAggregator.publish(Client.UpdateCartCount);
                _this.updatedCart();
                window.dataLayer.push({
                    "event": "navigate_to_cart",
                    "brandLotteryId": _this.brandLotteryId,
                    "openedLotteryName": _this.lottery.lotteryName,
                    "openedLotteryId": _this.lottery.lotteryId,
                });
            }, function (x) {
                _this.isUpdating = false;
                _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
            });
        }
    };
    Object.defineProperty(BaseChooseTickets.prototype, "freeTicketsUsed", {
        get: function () {
            var count = 0;
            this.freeTicketToggles.forEach(function (v) { if (v)
                count++; });
            return count;
        },
        enumerable: false,
        configurable: true
    });
    BaseChooseTickets.prototype.calculateFreeTicketSavings = function () {
        var _this = this;
        if (!this.ticketPrice || this.freeTicketsUsed === 0)
            return null;
        var savings = this.roundToTwoDecimalPlaces(this.ticketPrice.price * this.freeTicketsUsed);
        var symbol = Enumerable.from(this.tokenClient.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; }).symbol;
        return symbol + savings.toFixed(2);
    };
    BaseChooseTickets.prototype.calculateTotalPriceAfterFreeTickets = function () {
        var _this = this;
        if (!this.ticketPrice)
            return this.tokenClient.getCurrencySymbol() + '0.00';
        var savings = this.roundToTwoDecimalPlaces(this.ticketPrice.price * this.freeTicketsUsed);
        var net = this.roundToTwoDecimalPlaces(this.getDiscountedPrice() - savings);
        var symbol = Enumerable.from(this.tokenClient.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; }).symbol;
        return symbol + Math.max(0, net).toFixed(2);
    };
    BaseChooseTickets.prototype.toggleFreeTicket = function (ticket) {
        if (!this.tokenClient.isAuthenticated)
            return;
        if (!this.lottery || !this.lottery.freeTicketCount)
            return;
        var current = this.freeTicketToggles.get(ticket.guid) || false;
        if (!current && this.freeTicketsUsed >= this.lottery.freeTicketCount)
            return;
        this.freeTicketToggles.set(ticket.guid, !current);
        this.freeTicketToggles = new Map(this.freeTicketToggles); // trigger Aurelia change detection
        this.updateTotalPrice(); // re-evaluate signal-bound savings/total expressions
    };
    BaseChooseTickets.prototype.getCreateTicketRequest = function (ticket) {
        var selectedDraw = Enumerable.from(this.discountOffers).firstOrDefault(function (x) { return x.isSelected; });
        return {
            bundleGuid: this.getRemainingNumbers(ticket) == 0 ? this.bundleGuid : null,
            cartGuid: this.getRemainingNumbers(ticket) == 0 ? this.cartGuid : null,
            sequenceNumber: this.tickets.indexOf(ticket),
            bonusPicks: ticket.bonus.join(","),
            mainPicks: ticket.main.join(","),
            ticketGuid: ticket.guid,
            ticketId: ticket.ticketId,
            brandLotteryId: this.brandLotteryId,
            draws: selectedDraw ? selectedDraw.numberOfDraws : 0,
            recordedSessionId: Client.RECORDING_SESSION_ID,
            isFromCart: this.isFromCart,
            isFreeTicket: this.freeTicketToggles.get(ticket.guid) || false
        };
    };
    BaseChooseTickets.prototype.getRemainingBonus = function (ticket) {
        if (this.lottery)
            return this.lottery.drawnBonusNumbers - ticket.bonus.length;
        return 0;
    };
    BaseChooseTickets.prototype.getRemainingMain = function (ticket) {
        if (this.lottery)
            return this.lottery.drawnNumbers - ticket.main.length;
        return 0;
    };
    BaseChooseTickets.prototype.getRandom = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    };
    BaseChooseTickets.prototype.updateTicketNumbers = function () {
        var _this = this;
        // Clear free ticket toggle for any ticket that is no longer fully completed
        var toggled = false;
        this.freeTicketToggles.forEach(function (v, guid) {
            if (v) {
                var ticket = Enumerable.from(_this.tickets).firstOrDefault(function (t) { return t.guid === guid; });
                if (!ticket || _this.getRemainingNumbers(ticket) > 0) {
                    _this.freeTicketToggles.set(guid, false);
                    toggled = true;
                }
            }
        });
        if (toggled) {
            this.freeTicketToggles = new Map(this.freeTicketToggles);
        }
        this.bindingSignaler.signal('update-selected-ticket-numbers');
        this.updateTotalPrice();
    };
    BaseChooseTickets.prototype.isSelectedMainNumber = function (ticket, number) {
        var index = ticket.main.indexOf(number);
        return index >= 0;
    };
    BaseChooseTickets.prototype.isSelectedBonusNumber = function (ticket, number) {
        var index = ticket.bonus.indexOf(number);
        return index >= 0;
    };
    BaseChooseTickets.prototype.updateTotalPrice = function () {
        this.bindingSignaler.signal('selected-offer-signal');
    };
    BaseChooseTickets.prototype.calculateDiscountedTicketPrice = function (discountModel) {
        var discountedRoundedPrice = this.calculateDiscountedPrice(discountModel.discount, this.ticketPrice);
        var finalPrice = Math.round(discountedRoundedPrice * 100) / 100;
        // console.log("Ticket Price: " + this.ticketPrice.price);
        // console.log("Discounted Ticket Price: " + discountedRoundedPrice);
        // console.log("Rounded Nearest Price: " + roundedPrice);
        // console.log("Discounted Final Rounded Ticket Price: " + finalPrice);
        return this.tokenClient.getCurrencySymbol() + this.roundToTwoDecimalPlaces(finalPrice).toFixed(2);
    };
    BaseChooseTickets.prototype.calculateCurrentDiscountedTicketPrice = function () {
        var discountedRoundedPrice = this.calculateDiscountedPrice(this.getSelectedOffer().discount, this.ticketPrice);
        return this.roundToTwoDecimalPlaces(discountedRoundedPrice).toFixed(2);
    };
    BaseChooseTickets.prototype.calculateDiscountedPrice = function (discount, priceModel) {
        var roundedPrice = priceModel.price;
        var discountedRoundedPrice = roundedPrice - this.roundToTwoDecimalPlaces((roundedPrice * discount) / 100);
        return discountedRoundedPrice;
    };
    BaseChooseTickets.prototype.getStandardTicketPrice = function () {
        var _this = this;
        if (this.ticketPrice) {
            var ticketCurrency = Enumerable.from(this.tokenClient.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; });
            return ticketCurrency.symbol + this.roundToTwoDecimalPlaces(this.ticketPrice.price).toFixed(2);
        }
        return "";
    };
    BaseChooseTickets.prototype.isLastItem = function (discountModel) {
        var lotteryBrandDiscountModel = Enumerable.from(this.discountOffers).lastOrDefault();
        var isLastItem = lotteryBrandDiscountModel.lotteryBrandDiscountId == discountModel.lotteryBrandDiscountId;
        return isLastItem;
    };
    BaseChooseTickets.prototype.getSelectedOffer = function () {
        var selected = Enumerable.from(this.discountOffers).firstOrDefault(function (x) { return x.isSelected; });
        return selected;
    };
    BaseChooseTickets.prototype.calculateTotalLines = function () {
        var _this = this;
        return Enumerable.from(this.tickets).where(function (ticket) { return _this.getRemainingNumbers(ticket) === 0; }).toArray().length;
    };
    BaseChooseTickets.prototype.getRemainingNumbers = function (ticket) {
        return this.getRemainingMain(ticket) + this.getRemainingBonus(ticket);
    };
    BaseChooseTickets.prototype.calculateTotalPrice = function () {
        var _this = this;
        if (this.ticketPrice) {
            var ticketCurrency = Enumerable.from(this.tokenClient.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; });
            return ticketCurrency.symbol + this.roundToTwoDecimalPlaces(this.getDiscountedPrice()).toFixed(2);
        }
        return this.tokenClient.getCurrencySymbol() + "0.00";
    };
    BaseChooseTickets.prototype.getDiscountedPrice = function () {
        var _this = this;
        var ticketPicks = Enumerable.from(this.tickets).where(function (ticket) { return _this.getRemainingNumbers(ticket) === 0; }).toArray().length;
        var draws = this.getSelectedOffer() ? this.getSelectedOffer().numberOfDraws : 1;
        var discount = this.getSelectedOffer() ? this.getSelectedOffer().discount : 0;
        return (this.roundToTwoDecimalPlaces(this.calculateDiscountedPrice(discount, this.ticketPrice) * ticketPicks) * draws);
    };
    BaseChooseTickets.prototype.calculateTotalPriceWithoutDiscountInternal = function () {
        var _this = this;
        var ticketPicks = Enumerable.from(this.tickets).where(function (ticket) { return _this.getRemainingNumbers(ticket) === 0; }).toArray().length;
        var draws = this.getSelectedOffer() ? this.getSelectedOffer().numberOfDraws : 1;
        return (this.roundToTwoDecimalPlaces(this.ticketPrice.price * ticketPicks) * draws);
    };
    BaseChooseTickets.prototype.calculateTotalPriceWithoutDiscount = function () {
        var _this = this;
        if (this.ticketPrice) {
            var ticketCurrency = Enumerable.from(this.tokenClient.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; });
            return ticketCurrency.symbol + this.roundToTwoDecimalPlaces(this.calculateTotalPriceWithoutDiscountInternal()).toFixed(2);
        }
        return this.tokenClient.getCurrencySymbol() + "0.00";
    };
    BaseChooseTickets.prototype.calculateTotalDiscountPrice = function () {
        var _this = this;
        if (this.ticketPrice) {
            var ticketCurrency = Enumerable.from(this.tokenClient.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; });
            return ticketCurrency.symbol + this.roundToTwoDecimalPlaces(this.calculateTotalPriceWithoutDiscountInternal() - this.getDiscountedPrice()).toFixed(2);
        }
        return this.tokenClient.getCurrencySymbol() + "0.00";
    };
    BaseChooseTickets.prototype.roundToTwoDecimalPlaces = function (x) {
        // 0.075 with the .toFixed does not round correctly
        return Math.round(x * 100) / 100;
    };
    BaseChooseTickets.prototype.navigateToLobby = function () {
        this.router.navigateToRoute(RouterConstants.RouteNames.Lobby);
    };
    BaseChooseTickets.prototype.pickOne = function () {
        var firstTicketWithNoPicks = this.getFirstTicket();
        if (firstTicketWithNoPicks == null)
            this.addLines();
        firstTicketWithNoPicks = firstTicketWithNoPicks == null ? this.getFirstTicket() : firstTicketWithNoPicks;
        if (firstTicketWithNoPicks != null) {
            this.pickRandom(firstTicketWithNoPicks);
            this.updateTotalPrice();
        }
    };
    BaseChooseTickets.prototype.editOne = function () {
        var firstTicketWithNoPicks = this.getFirstTicket();
        if (firstTicketWithNoPicks == null)
            this.addLines();
        this.isFirstTime = false;
        this.ticketInEdit = firstTicketWithNoPicks == null ? this.getFirstTicket() : firstTicketWithNoPicks;
        var navHeight = $(".common-navigation-menu")[0] ? $(".common-navigation-menu")[0].clientHeight : 0;
        var chooseTicketHeight = $("choose-ticket").height() + navHeight;
        this.sendHeightToClient(chooseTicketHeight + "px", true);
    };
    BaseChooseTickets.prototype.editTicket = function (ticket) {
        this.isFirstTime = false;
        this.ticketInEdit = ticket;
        var navHeight = $(".common-navigation-menu")[0] ? $(".common-navigation-menu")[0].clientHeight : 0;
        var chooseTicketHeight = $("choose-ticket").height() + navHeight;
        this.sendHeightToClient(chooseTicketHeight + "px", true);
    };
    BaseChooseTickets.prototype.getFirstTicket = function () {
        return Enumerable.from(this.tickets).firstOrDefault(function (x) { return !x.main || x.main.length == 0; });
    };
    BaseChooseTickets.prototype.shouldScrollTopOnLoad = function () {
        return false;
    };
    __decorate([
        bindable(),
        __metadata("design:type", Number)
    ], BaseChooseTickets.prototype, "brandLotteryId", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", LotteryClientModel)
    ], BaseChooseTickets.prototype, "lottery", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", Boolean)
    ], BaseChooseTickets.prototype, "showPurchaseStep", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", String)
    ], BaseChooseTickets.prototype, "key", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", Boolean)
    ], BaseChooseTickets.prototype, "isDialog", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", Boolean)
    ], BaseChooseTickets.prototype, "isFromCart", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", String)
    ], BaseChooseTickets.prototype, "cartGuid", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", String)
    ], BaseChooseTickets.prototype, "bundleGuid", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", Number)
    ], BaseChooseTickets.prototype, "draws", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", Object)
    ], BaseChooseTickets.prototype, "ticketInEdit", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", Boolean)
    ], BaseChooseTickets.prototype, "isSubscribe", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", Boolean)
    ], BaseChooseTickets.prototype, "isFirstTime", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", Boolean)
    ], BaseChooseTickets.prototype, "canRevert", void 0);
    __decorate([
        computedFrom("lottery", "lottery.lotteryGroups"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BaseChooseTickets.prototype, "lotteryGroups", null);
    return BaseChooseTickets;
}(BaseTemplate));
export { BaseChooseTickets };
